// redux/store.ts
import { configureStore } from '@reduxjs/toolkit';
import configReducer from './slices/configSlice';
import playersReducer from './slices/playersSlice';
import userReducer from './slices/userSlice';
import chatReducer from './slices/chatSlice'; // legacy socket-based chat
import pageReducer from './slices/pageSlice';
import engagementReducer from './slices/engagementSlice';
import { useDispatch } from 'react-redux';
import { twilioChatReducer } from '../twilio/store/reducer';

const store = configureStore({
  reducer: {
    config: configReducer,
    players: playersReducer,
    user: userReducer,
    chat: chatReducer,
    page: pageReducer,
    engagement: engagementReducer,
    twilioChat: twilioChatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore non-serializable checks for these action types/paths (Twilio objects)
        ignoredActions: ['TWILIO_ACTION_START_SESSION', 'TWILIO_ACTION_ADD_MESSAGE', 'TWILIO_ACTION_UPDATE_MESSAGE', 'TWILIO_ACTION_REMOVE_MESSAGE', 'TWILIO_ACTION_UPDATE_CONVERSATION_STATE'],
        ignoredPaths: [
          'twilioChat.conversation',
          'twilioChat.messages',
          'twilioChat.participants',
          'twilioChat.users',
          'twilioChat.conversationState',
        ],
      },
      // Disable immutability check for performance and to avoid deep traversal of Twilio objects
      immutableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export default store;
